import { Grid, Stack } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { FieldItemProps } from "./areaFiledItem.types.ts";
import AreaFieldItemLoader from "./AreaFieldItemLoader.tsx";
import FieldItemCaptions from "./FieldItemCaptions.tsx";
import FieldItemOptionsButton from "./FieldItemOptionsButton.tsx";

const AreaFieldItem = <T,>({
  field,
  hideOptions,
  isLoading,
  readonly,
  formatCaption,
  onShowOptions,
  optionRef,
  disableEqualitySelection,
  autoShowItemOptionsId,
  onSetAutoShowItemOptionsId,
}: FieldItemProps<T>) => {
  const [optionElementRef, setOptionElementRef] = useState<HTMLElement | null>(null);

  useEffect(() => {
    optionRef?.call(null, optionElementRef);
  }, [optionRef, optionElementRef]);

  const showOptions = useCallback(() => {
    if (!onShowOptions) return false;
    const ref = optionElementRef;
    if (!ref) return false;

    onShowOptions({ field: field, ref, showOnlySelected: false });
    return true;
  }, [optionElementRef, field, onShowOptions]);

  useEffect(() => {
    if (!autoShowItemOptionsId) return;
    const item = field as { config: { guid: string; filter: { guid: string } }; guid: string };
    if (
      autoShowItemOptionsId === item?.guid ||
      item.config?.guid === autoShowItemOptionsId ||
      item.config?.filter?.guid === autoShowItemOptionsId
    ) {
      if (showOptions()) {
        onSetAutoShowItemOptionsId?.();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoShowItemOptionsId, field, showOptions]);

  return (
    <>
      {isLoading === true && <AreaFieldItemLoader />}
      <Stack
        sx={(t) => ({
          justifyContent: "space-between",
          minHeight: "30px",
          width: "100%",
          overflow: "hidden",
          flex: 1,
          backgroundColor: readonly ? t.palette.action.disabledBackground : "none",
        })}
      >
        <Grid container flex={1} minWidth={0} overflow={"hidden"} width={"100%"}>
          <FieldItemCaptions
            field={field}
            formatCaption={formatCaption}
            disableEqualitySelection={disableEqualitySelection}
          />
          <FieldItemOptionsButton hideOptions={hideOptions} showOptions={showOptions} ref={setOptionElementRef} />
        </Grid>
      </Stack>
    </>
  );
};
export default AreaFieldItem;
